module.exports = __webpack_public_path__ + "static/media/MetallurgyBearing.c21f6889.png";